import { render, staticRenderFns } from "./SelectCategoriesModal.vue?vue&type=template&id=4467ad77&scoped=true"
import script from "./SelectCategoriesModal.vue?vue&type=script&lang=js"
export * from "./SelectCategoriesModal.vue?vue&type=script&lang=js"
import style0 from "./SelectCategoriesModal.vue?vue&type=style&index=0&id=4467ad77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4467ad77",
  null
  
)

export default component.exports